/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {FileType} from './FileType';

/**
 * The EmailsCheckResultFiles model module.
 * @module model/EmailsCheckResultFiles
 * @version 1.0.0
 */
export class EmailsCheckResultFiles {
  /**
   * Constructs a new <code>EmailsCheckResultFiles</code>.
   * @alias module:model/EmailsCheckResultFiles
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsCheckResultFiles</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsCheckResultFiles} obj Optional instance to populate.
   * @return {module:model/EmailsCheckResultFiles} The populated <code>EmailsCheckResultFiles</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsCheckResultFiles();
      if (data.hasOwnProperty('full'))
        obj.full = FileType.constructFromObject(data['full']);
      if (data.hasOwnProperty('verified'))
        obj.verified = FileType.constructFromObject(data['verified']);
      if (data.hasOwnProperty('active_verified'))
        obj.active_verified = FileType.constructFromObject(data['active_verified']);
    }
    return obj;
  }
}

/**
 * @member {module:model/FileType} full
 */
EmailsCheckResultFiles.prototype.full = undefined;

/**
 * @member {module:model/FileType} verified
 */
EmailsCheckResultFiles.prototype.verified = undefined;

/**
 * @member {module:model/FileType} active_verified
 */
EmailsCheckResultFiles.prototype.active_verified = undefined;

